import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse } from '../models/api-response.model';
import { NotificacionCanalDto } from '../models/notificacion-canal.model';
import { AuthService } from './auth.service';
import { BaseApiService } from './api-base.service';
import { ConfigService } from './config.service';
import { ConfigClientService } from './configClient.service';
import { SINERGIAL_ROUTES } from '../constants/api-sinergial-routes';

const DEFAULT_PARAMS = {
  orden: 2,
  SentidoOrden: 'asc',
  pageNumber: -1,
} as const;

@Injectable({ providedIn: 'root' })
export class NotificacionCanalService extends BaseApiService<ApiResponse<NotificacionCanalDto[]>> {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    authService: AuthService,
    configClientService: ConfigClientService,
  ) {
    super(http, configService, configClientService, authService);
  }

  getCanales(
    extra?: Record<string, string | number | boolean>,
  ): Observable<ApiResponse<NotificacionCanalDto[]>> {
    return this.get<ApiResponse<NotificacionCanalDto[]>>(SINERGIAL_ROUTES.NOTIFICACION_CANAL.PATH_BASE, {
      params: { ...DEFAULT_PARAMS, ...extra },
    });
  }
}
